import objectFitImages from 'object-fit-images';

import Home from './renderers/home';
import Shop from './renderers/shop';
import Product from './renderers/product';
import Gang from './renderers/gang';
import About from './renderers/about';
import Cart from './renderers/cart';
import BigOrder from './renderers/bigorder';
import Nav from './components/nav';

objectFitImages();

document.addEventListener('DOMContentLoaded', () => {
	// DOM loaded
    new Nav();

	if(document.body.classList.contains('home')){
    	new Home();
	}

	if(document.body.classList.contains('page-template-shop')){
    	new Shop();
	}

	if(document.body.classList.contains('single-product')){
    	new Product();
	}

	if(document.body.classList.contains('page-template-gang')){
    	new Gang();
	}

	if(document.body.classList.contains('page-template-about')){
    	new About();
	}

	if(document.body.classList.contains('page-template-cart')){
    	new Cart();
	}

  if(document.body.classList.contains('page-template-big-order')){
      new BigOrder();
  }
});